/*
 * Groessen-Kacheln (Design BF26) - Gegenstueck zu snippets/ll-size-tiles.liquid.
 *
 * Wird nur geladen, wenn Kacheln auf der Seite sind. Die Startanzeige rendert Liquid. Dieses Script aktualisiert nur
 * Ampel-Punkt und Kurzstatus der Kacheln, wenn sich eine andere Option aendert (z. B. Farbe), damit jede Kachel den
 * Status der Variante mit der aktuellen Auswahl zeigt. Datenquelle ist dasselbe data-traffic-json wie beim
 * Variant Picker 2.0. Auswahl und variant:change macht weiter die Basisklasse VariantPicker.
 */
const readTraffic = (container) => {
  if (!container.llTraffic) {
    try {
      const picker = container.closest("variant-picker-tm");
      container.llTraffic = JSON.parse(picker.querySelector("[data-traffic-json]").textContent).variants || [];
    } catch {
      container.llTraffic = [];
    }
  }
  return container.llTraffic;
};

const statusFor = (container, entry) => {
  const lowStock = Number(container.dataset.lowStock) || 3;
  const stock = Number(entry?.inventory_quantity) || 0;
  let color = entry?.color || (entry ? (stock > 0 ? "--available" : "--unavailable") : "--unavailable");

  if (color === "--available") {
    const text = stock > 0 && stock <= lowStock
      ? container.dataset.textLow.replace("%stock%", stock)
      : container.dataset.textAvailable;
    return { color, text, unavailable: false };
  }
  if (color === "--almostsoldout") {
    return { color, text: container.dataset.textSoon, unavailable: false };
  }
  color = "--unavailable";
  return { color, text: container.dataset.textUnavailable, unavailable: true };
};

const updateTiles = (container, selectedOptions) => {
  const position = Number(container.dataset.position) - 1;
  const variants = readTraffic(container);

  container.querySelectorAll("[data-option-value]").forEach((tile) => {
    const value = tile.getAttribute("data-option-value");
    const entry = variants.find((variant) => Array.isArray(variant.options) && variant.options.every((option, index) => (
      index === position ? option === value : option === selectedOptions[index]
    )));
    const status = statusFor(container, entry);

    tile.classList.toggle("is-unavailable", status.unavailable);
    tile.querySelector(".ll-size-tile__status")?.style.setProperty("--dot-color", `var(${status.color})`);
    const text = tile.querySelector("[data-ll-tile-text]");
    if (text && text.textContent !== status.text) {
      text.textContent = status.text;
    }
  });
};

document.addEventListener("variant:change", (event) => {
  // getAttribute statt .id: Das Produktformular enthaelt <input name="id">, dadurch liefert form.id das Eingabefeld.
  const formId = event.target?.getAttribute?.("id");
  const options = event.detail?.variant?.options;
  if (!formId || !Array.isArray(options)) {
    return;
  }
  document.querySelectorAll(`[data-ll-size-tiles][data-form="${CSS.escape(formId)}"]`)
    .forEach((container) => updateTiles(container, options));
});
